'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002412 from "./presto.-Register-Page-View$$anon$12.js";
import * as $j_presto$002etypes$0024$002dCompact$002dFeature$0024 from "./presto.types$-Compact-Feature$.js";
import * as $j_presto$002etypes$0024$002dFeature$002dCode$0024 from "./presto.types$-Feature-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterPageView$$anon$11() {
  this.bsL = null;
  this.bsD = null;
  this.bsE = false;
  this.bsM = null;
  this.bsN = false;
  this.bsQ = null;
  this.bsJ = null;
  this.bsK = false;
  this.bsF = null;
  this.bsG = false;
  this.bsH = null;
  this.bsI = false;
  this.bsO = false;
  this.bsP = false;
  this.bsL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bsQ = "CompactFeature";
}
export { $c_Lpresto_RegisterPageView$$anon$11 as $c_Lpresto_RegisterPageView$$anon$11 };
$p = $c_Lpresto_RegisterPageView$$anon$11.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterPageView$$anon$11;
/** @constructor */
function $h_Lpresto_RegisterPageView$$anon$11() {
}
export { $h_Lpresto_RegisterPageView$$anon$11 as $h_Lpresto_RegisterPageView$$anon$11 };
$h_Lpresto_RegisterPageView$$anon$11.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bsL;
});
$p.M = (function() {
  if ((!this.bsE)) {
    this.bsD = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bsE = true;
  }
  return this.bsD;
});
$p.O = (function() {
  if ((!this.bsN)) {
    this.bsM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bsN = true;
  }
  return this.bsM;
});
$p.E = (function() {
  return this.bsQ;
});
$p.t = (function() {
  if ((!this.bsK)) {
    this.bsJ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("value", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bsK = true;
  }
  return this.bsJ;
});
$p.N = (function() {
  if ((!this.bsG)) {
    this.bsF = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dFeature$002dCode$0024.$m_Lpresto_types$FeatureCode$().adf(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().eB)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bsG = true;
  }
  return this.bsF;
});
$p.Q = (function() {
  if ((!this.bsI)) {
    this.bsH = new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002412.$c_Lpresto_RegisterPageView$$anon$12();
    this.bsI = true;
  }
  return this.bsH;
});
$p.v = (function() {
  if ((!this.bsP)) {
    this.bsO = false;
    this.bsP = true;
  }
  return this.bsO;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee92) => ((p) => \u03b4scrutinee92.acT(p)))($j_presto$002etypes$0024$002dCompact$002dFeature$0024.$m_Lpresto_types$CompactFeature$())));
});
var $d_Lpresto_RegisterPageView$$anon$11 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterPageView$$anon$11, "presto.RegisterPageView$$anon$11", ({
  Qf: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_RegisterPageView$$anon$11 as $d_Lpresto_RegisterPageView$$anon$11 };
//# sourceMappingURL=presto.-Register-Page-View$$anon$11.js.map
